<template>
  <div class="flex relative">
    <left-bar />
    <div class="content w-full mx-12 main-content min-h-screen pt-12">
      <FeatureNav />
      <router-view />
    </div>
    <ProfileNav />
  </div>
</template>

<script>
  import FeatureNav from '@/components/FeatureNav';
  import ProfileNav from '@/components/ProfileNav'
  import LeftBar from '@/components/LeftBar.vue';

  export default {
    components: {
      FeatureNav, 
      ProfileNav, 
      LeftBar
    },
  }
</script>

<style lang="scss" scoped>

</style>